import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import noImage from '../../images/no_image.png'
export default class UserRow extends Component {

  image(user) {
    if(user.photo) {
      return <img className='rounded-circle' height="80" width="80" src={user.photo} alt='' />
    } else {
      return <img height="80" src={noImage} alt='' />
    }
  }

  getGB() {
    var attrs = this.props.user.user_display_list_attributes
    if(attrs.length !== 0) {
      return 'Governing Body'
    }
  }

  getModeratorStatus() {
    if(this.props.user.isModerator) {
      return <div className='user-moderator'>Moderator</div>
    }
  }

  isBusinessCardConnection() {
    if(this.props.user.is_biz_card && this.props.hideIcons !== true){
      return <li><i className="fa fa-id-card-o" aria-hidden="true"></i></li>
    }
  }

  hasNoteOnUser() {
    if(this.props.user.note_on_user && this.props.hideIcons !== true){
      return <li><i className="fa fa-sticky-note-o" aria-hidden="true"></i></li>
    }
  }

  userNote(user) {
    if(this.props.user.note_on_user && this.props.isNoteIndex) {
      return <div className='note'>{user.note_on_user}</div>
    }
  }

  render() {
    const ellipsis = this.props.skipEllipsis === true ? '' : 'ellipsis'
    var user = this.props.user
    var skipGb = this.props.skipGB
    var noteTakingStatus = this.props.isTakingNotes
    let has_logged_in = !user.is_logged_in && this.props.dimUsers === true ? 'dim' : ''
    let noHover = !user.is_logged_in || this.props.noHover === true ? 'nohover' : 'hover'
    let addClass = this.props.addClass
    let userLink = this.props.skipLink || !user.is_logged_in ? '' : '/user/' + user.id
    let userProfileUrl = this.props.user.user_id === window.currentUser.user_id ? '/my_profile' : userLink
    return (
      <Link
        className={ has_logged_in ? 'user-list-link' : '' }
        to={{
          pathname: userProfileUrl,
          state: {
            noteTakingStatus: noteTakingStatus,
            activeTab: this.props.activeTab
          }
        }}
        onClick={ this.props.action }
      >
        <div className={`user-list ${has_logged_in} ${noHover} ${addClass}`}>
          {this.image(user)}
          <div className={'user-info ' + ellipsis}>
            <div className={'user-fullname '}><strong>{user.first_name} {user.last_name}</strong></div>
            <div className={'user-fullname '}>{user.title}</div>
            <div className={'user-fullname '}>{user.organization_name}</div>
            { !skipGb &&
              <div className={'user-gb '}>{this.getGB()}</div>
            }
            {this.getModeratorStatus()}
          </div>
          <div className="user-icons">
            <ul>
              {this.isBusinessCardConnection()}
              {this.hasNoteOnUser()}
            </ul>
          </div>
          {this.userNote(user)}
        </div>
      </Link>
    )
  }
}
